import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, TrendingUp, TrendingDown, Wallet } from "lucide-react";
import { api } from "../../lib/api";
import SelectField from "../../components/os/SelectField";
import DatePicker from "../../components/os/DatePicker";

const mxn = (v) => Number(v || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 });

export default function ModuleEventFinance({ moduleKey, item, onRefresh }) {
  const [tipo, setTipo] = useState("gasto");
  const [concepto, setConcepto] = useState("");
  const [monto, setMonto] = useState("");
  const [fecha, setFecha] = useState("");
  const [busy, setBusy] = useState(false);
  const movs = item.movimientos || [];
  const ingresos = movs.filter((m) => m.tipo === "ingreso").reduce((a, m) => a + Number(m.monto || 0), 0);
  const gastos = movs.filter((m) => m.tipo === "gasto").reduce((a, m) => a + Number(m.monto || 0), 0);
  const neto = ingresos - gastos;

  const add = async () => {
    if (!concepto.trim()) return toast.error("Concepto obligatorio");
    setBusy(true);
    try {
      await api.post(`/mod/${moduleKey}/items/${item.id}/movimiento`, { tipo, concepto, monto, fecha });
      setConcepto(""); setMonto(""); setFecha("");
      onRefresh?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };
  const del = async (id) => { try { await api.delete(`/mod/${moduleKey}/items/${item.id}/movimiento/${id}`); onRefresh?.(); } catch {} };

  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-3" data-testid="module-event-finance">
      <div className="flex items-center gap-2 overline text-navy/40"><Wallet className="w-3.5 h-3.5" /> Facturas y movimientos (ingreso / gasto)</div>
      <div className="grid grid-cols-3 gap-2">
        <div className="rounded-lg border border-navy/10 p-2.5"><div className="text-[10px] text-navy/40 flex items-center gap-1"><TrendingUp className="w-3 h-3 text-emerald-600" /> Ingresos</div><div className="text-sm font-medium text-emerald-600" data-testid="finance-ingresos">{mxn(ingresos)}</div></div>
        <div className="rounded-lg border border-navy/10 p-2.5"><div className="text-[10px] text-navy/40 flex items-center gap-1"><TrendingDown className="w-3 h-3 text-destructive" /> Gastos</div><div className="text-sm font-medium text-destructive" data-testid="finance-gastos">{mxn(gastos)}</div></div>
        <div className="rounded-lg border border-navy/10 p-2.5 bg-navy/[0.02]"><div className="text-[10px] text-navy/40">Neto</div><div className={`text-sm font-medium ${neto >= 0 ? "text-navy" : "text-destructive"}`} data-testid="finance-neto">{mxn(neto)}</div></div>
      </div>
      {movs.length > 0 && (
        <div className="space-y-1.5">
          {movs.map((m) => (
            <div key={m.id} className="flex items-center gap-2 text-sm border border-navy/10 rounded-lg px-3 py-2" data-testid={`finance-mov-${m.id}`}>
              <span className={`w-1.5 h-1.5 rounded-full ${m.tipo === "ingreso" ? "bg-emerald-500" : "bg-destructive"}`} />
              <span className="flex-1 truncate text-navy/80">{m.concepto}</span>
              {m.fecha && <span className="text-xs text-navy/40">{m.fecha}</span>}
              <span className={`font-medium ${m.tipo === "ingreso" ? "text-emerald-600" : "text-destructive"}`}>{m.tipo === "ingreso" ? "+" : "−"}{mxn(m.monto)}</span>
              <button onClick={() => del(m.id)} className="text-navy/20 hover:text-destructive"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          ))}
        </div>
      )}
      <div className="grid grid-cols-2 gap-2 items-end">
        <div><label className="text-[11px] text-navy/50 mb-1 block">Tipo</label><SelectField testid="finance-tipo" value={tipo} options={[{ value: "gasto", label: "Gasto" }, { value: "ingreso", label: "Ingreso" }]} onChange={setTipo} /></div>
        <div><label className="text-[11px] text-navy/50 mb-1 block">Monto</label><input type="number" step="any" value={monto} onChange={(e) => setMonto(e.target.value)} data-testid="finance-monto" className="w-full bg-white border border-navy/10 rounded-lg px-3 py-2 outline-none focus:border-violet text-sm" /></div>
        <div className="col-span-2"><label className="text-[11px] text-navy/50 mb-1 block">Concepto</label><input value={concepto} onChange={(e) => setConcepto(e.target.value)} data-testid="finance-concepto" className="w-full bg-white border border-navy/10 rounded-lg px-3 py-2 outline-none focus:border-violet text-sm" /></div>
        <div><label className="text-[11px] text-navy/50 mb-1 block">Fecha</label><DatePicker testid="finance-fecha" value={fecha} onChange={setFecha} placeholder="Fecha" /></div>
        <button onClick={add} disabled={busy} className="btn btn-primary" data-testid="finance-add-btn"><Plus className="w-4 h-4" /> Agregar</button>
      </div>
    </div>
  );
}
